import React, { useState, useEffect, useRef } from 'react';
import jobServices from 'ApiService/Student/jobServices';

const CardCountdown = ({ assignmentId, assignedDate, assignmentExpiry, viewedAt, studentJobResponse, studentRevert, rounds }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [colorClass, setColorClass] = useState('');
  const expiredRef = useRef(false);

  const hasRoundResponse = rounds?.some(
    (r) => r.studentStatus && r.studentStatus !== 'Pending'
  );

  const expiryHours = assignmentExpiry || 24;

  useEffect(() => {
    if (studentJobResponse !== 'Pending' || studentRevert !== 'Pending' || hasRoundResponse) return;

    const assignedAt = new Date(assignedDate).getTime();
    const deadline = assignedAt + expiryHours * 60 * 60 * 1000;

    const updateTimer = () => {
      const now = Date.now();
      const diff = deadline - now;

      if (diff <= 0) {
        setTimeLeft('Expired');
        setColorClass('text-red-600 font-bold');
        if (!expiredRef.current && assignmentId) {
          expiredRef.current = true;
          jobServices.checkAssignmentExpiry(assignmentId).catch(() => {});
        }
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft(`${hours}h ${minutes}m ${seconds}s left`);

      if (hours < 1) {
        setColorClass('text-red-600 font-bold');
      } else if (hours < 3) {
        setColorClass('text-yellow-600 font-bold');
      } else {
        setColorClass('text-green-600');
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [assignmentId, assignedDate, expiryHours, viewedAt, studentJobResponse, studentRevert, hasRoundResponse]);

  if (studentJobResponse !== 'Pending' || studentRevert !== 'Pending' || hasRoundResponse) return null;

  return (
    <div className={`text-xs font-medium ${colorClass}`}>
      ⏰ {timeLeft}
    </div>
  );
};

export default CardCountdown;
